<template>
  <div class="card card-body card-procces-id-main-box mb-5 border-0">
    <div class="row d-flex justify-content-start">
      <h3 style="font-size: 1.2vw !important;">مشخصات ورودی‌های فرآيند</h3>
    </div>
    <form class="needs-validation mt-2 mb-3" novalidate>
      <div class="d-flex flex-nowrap justify-content-evenly">
        <div class="col-lg-2 mb-3 ms-n-1">
          <label class="form-label">شرح ورودي فرآيند</label>
          <input v-model="title" class="form-control" type="text" name="" required>
        </div>
        <div class="col-lg-2 mb-3 ms-n-1">
          <label class="form-label">نوع تأمین کننده</label>
          <select v-model="supplier" class="form-select" name="" required>
            <option selected value="1">فرآیند</option>
            <option value="2">ذی نفع</option>
          </select>
        </div>
        <div class="col-lg-2 mb-3 ms-n-1">
          <label class="form-label">سطح تأمين كننده </label>

          <select v-if="supplier==1" v-model="type" class="form-select" name="" required>
            <option value="1">طبقه</option>
            <option value="2">گروه</option>
            <option value="3">فرآیند</option>
            <option value="4">زیر فرآیند</option>
          </select>
          <select v-else v-model="type" class="form-select" name="" required>
            <option value="2">گروه</option>
            <option value="1">ذی نفع</option>
          </select>
        </div>
        <div class="col-lg-2 mb-3 ms-n-1">
          <label class="form-label">تأمين كننده ورودی</label>
          <input v-model="inserterName" class="form-control" type="text" name="" readonly
                 placeholder="انتخاب کنید" @click.prevent="showListInserter">
        </div>

        <div class="col-lg-1 mb-3" style="margin-right: 3vw">
          <button v-show="!editModal" @click.prevent="saveItem" class="btn btn-primary btn-submit-1" type="submit"
                  style="margin-top: 1.9vw; font-size: 2vw;">
            <span style="transform: translateY(.2vw)">+</span>
          </button>
          <button v-show="editModal" @click.prevent="update(item_id)" class="btn btn-primary btn-submit-1" type="submit"
                  style="margin-top: 1.9vw; font-size: 1vw;">
            <span style="">ویرایش</span>
          </button>
        </div>
      </div>
      <hr>
    </form>
    <div class="table-responsive">
      <center v-show="!all_items.length">
        <p>مشخصات ورودی فرآیند وجود ندارد</p>
      </center>
      <table v-show="all_items.length" class="table table-striped">
        <thead>
        <tr>
          <th>ردیف</th>
          <th>شرح ورودي فرآيند</th>
          <th>نوع تأمین کننده</th>
          <th>تأمين كننده ورودی</th>
          <th>عملیات</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item,index) in all_items">
          <td scope="row">{{index+1}}</td>
          <td>{{item.title}}</td>
          <td>
            <div  v-if="parseInt(item.supplier)===1">
              فرآیند

            </div>
            <div v-else>
              ذی نفع
            </div>

          </td>
          <td v-if="item.processes_self">{{item.processes_self.title}}</td>
          <td v-if="item.beneficiaries_self">{{item.beneficiaries_self.title}}</td>

          <td>
            <a @click.prevent="edit(item.id)" href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></a>
            <a @click.prevent="deleteModalMethod(item.id)" href="#"><img class="table-delete-img mx-2" src="/img/delete.f9fc94bc.svg" alt="delete"> </a>
          </td>
        </tr>

        </tbody>
      </table>
    </div>
  </div>

  <!-- modal -->
  <div dir="rtl" class="modal__error slide-top" v-show="select_inserter"
       style="z-index: 999999999999999999999999999999999999999999999; top: 25%;">
    <div>
      <p>تامین کننده ورودی</p>
      <p @click="select_inserter=!select_inserter">❌</p>
    </div>
    <div>
      <input v-model="search_inserter" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد و عنوان...">
      <table class="table table-striped">
        <thead>
        <tr>
          <th style="width: 1vw;">انتخاب</th>
          <th>کد</th>
          <th>عنوان</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredorganization" :key="item.id">
          <td scope="row"><input v-model="inserterId" type="radio" name="parent" :value="item['id']"></td>
          <td>{{ item['code'] }}</td>
          <td>{{ item['title'] }}</td>
        </tr>

        </tbody>
      </table>
      <button @click="select_inserterMethod">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 25%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(item_id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal -->
  <div dir="rtl" class="modal__error slide-top" v-show="error"
       style="z-index: 999999999999999999999999999999999999999999999; top: 25%;">
    <div>
      <p>   خطا  </p>
      <p @click="error=!error">❌</p>
    </div>
    <div>
      {{errorMessage}}



      <button @click="error=!error">بازگشت</button>
    </div>
  </div>
</template>
<script>
import {mapMutations, mapState} from "vuex";
import {all} from "core-js/internals/document-all";

export default {
  props: ['id_route', 'type'],
  data() {
    return {
      all_items: [],
      all_inserter: [],
      select_inserter: false,
      deleteModal: false,
      editModal: false,
      search_inserter: '',
      inserterId: '',
      title: '',
      inserterName: '',
      type: '',
      item_id: '',
      supplier: 1,
      error: false,
      errorMessage: false,

    }
  },


  methods: {
    deleteModalMethod(id){
      this.item_id=id
      this.deleteModal=true
    },
    deleteItemForm(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/supplier_input/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()
            this.deleteModal=false


          })
          .catch();
    },
    edit(id){
      this.item_id=id
      this.editModal=true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/supplier_input/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
           const item = response.item
            if (item){
              this.title=item.title
              this.supplier=item.supplier
            }

            if (item.processes_self){
              this.type=item.processes_self.type
              this.inserterName=item.processes_self.title
              this.inserterId=item.processes_self.id

            }  if (item.beneficiaries_self){
              this.type=item.beneficiaries_self.type
              this.inserterName=item.beneficiaries_self.title
              this.inserterId=item.beneficiaries_self.id


            }


          })
          .catch();
    },
    update(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();
      if (this.supplier === 1) {
        formdata.append('processes_self_id', this.inserterId)

      } else {
        formdata.append('beneficiaries_self_id', this.inserterId)
      }
      formdata.append('processes_id', this.id_route)
      formdata.append('title', this.title)
      formdata.append('supplier', this.supplier)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/supplier_input/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()
            this.inserterId=''
            this.title=''
            this.inserterName=''
            this.editModal=false



          })
          .catch();
    },
    saveItem() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();
      if (this.supplier === 1) {
        formdata.append('processes_self_id', this.inserterId)

      } else {
        formdata.append('beneficiaries_self_id', this.inserterId)
      }
      formdata.append('processes_id', this.id_route)
      formdata.append('title', this.title)
      formdata.append('supplier', this.supplier)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/supplier_input/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.addToSharedList()
            this.showItem()
            this.inserterId=''
            this.title=''
            this.inserterName=''

          })
          .catch();

    },
    getInformations() {
      fetch(`${this.base_url}/processes/information_by_id/${this.id_route}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',

        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response) {
              if (response.item) {
                this.type = response.item.type

              }

            }

          }).catch((err) => {
      })
    },
    // *************************************************
    // *************************************************
    // *************************************************
    ...mapMutations(['setSharedList']),
    addToSharedList() {
      this.setSharedList(true);

    },
    showListInserter() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/supplier_input/list/${this.supplier}/${this.type}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.all_inserter.length = 0

            if (result['all'].length !== 0) {
              result['all'].forEach(item => {
                this.all_inserter.push(item)
                this.select_inserter = true

              })

            }

          })
          .catch();
    },
    showItem() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/supplier_input/items/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all){
              this.all_items.length=0
              response.all.forEach((item)=>{
                this.all_items.push(item)
              })

            }


          })
          .catch();

    },
    select_inserterMethod() {
      this.all_inserter.forEach((ele) => {
        ele.id === this.inserterId ? this.inserterName = ele.title : ''
      })
      this.select_inserter = false


    },


  },
  computed: {
    all() {
      return all
    },
    ...mapState(['statusInformation']),
    filteredorganization() {
      return this.all_inserter.filter(item => {
        return (
            item['title'].includes(this.search_inserter) ||
            item['code'].toString().includes(this.search_inserter)
        );
      });
    },
  },
  mounted() {
    this.getInformations()
    this.showItem()
  }

}

</script>
<style scoped>
.table-striped > tbody > tr:nth-of-type(odd) {
  --bs-table-accent-bg: #D0E9FA57;
  color: var(--bs-table-striped-color);
}
</style>